import { forwardRef, memo } from 'react';
import { themeCssVar as theme } from '@tinderapp/ui-react';

import TinderIcon from 'Assets/reactSvgs/TinderIcon';

import './style.scss';

const LOADING_SCREEN_TESTID = 'loading-screen';

// @TODO, can't use design token as design token variables rendered after loading screen
// needs to change the timing of loading the token
const LoadingScreen = forwardRef<HTMLDivElement>((props, ref) => (
  <div
    className="loadingScreen CenterAlign StretchedBox Bgi($primary-gradient-vertical)"
    role="alert"
    aria-busy="true"
    ref={ref}
  >
    <div
      className="Animn($anim-logo) Animdur($xslow) Animic(i) Animtf($anim-logo-timing-func) Trfo(c)"
      data-testid={LOADING_SCREEN_TESTID}
      {...props}
    >
      <TinderIcon className="Sq(82px)" fill={theme.color.white} />
    </div>
  </div>
));

export default memo(LoadingScreen);
